/*

------------------------------------------------------------------------------------------------
🆁🅼🅽 22023 09 18 

------------------------------------------------------------------------------------------------
*/
import React, { useState, useRef } from "react";

const Mensaje = () => {
  //console.log(nombre.target.value)
  return (
    <section className="relative isolate overflow-hidden bg-white px-6 py-24 sm:py-32 lg:px-8">
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(45rem_50rem_at_top,theme(colors.indigo.100),white)] opacity-20" />
      <div />
      <div className="mx-auto max-w-2xl lg:max-w-4xl">
        <figure className="mt-10">
          <blockquote className="text-center text-xl font-semibold leading-8 text-gray-900 sm:text-2xl sm:leading-9">
            <p>
              <div
                className="bg-blue-100 border border-blue-400 text-white-700 px-4 py-3 rounded relative"
                role="alert"
              >
                <strong className="font-bold">
                  {" "}
                  ORDEN DE SERVICIO REGISTRADA!!
                </strong>
              {/*   <span className="block sm:inline">
                  Something seriously bad happened.
                </span> */}
                <span className="absolute top-0 bottom-0 right-0 px-4 py-3">
                 
                  
                </span>
              </div>
            </p>
          </blockquote>
          <figcaption className="mt-10">
            {/* <div className="mt-4 flex items-center justify-center space-x-3 text-base">
              <div className="font-semibold text-gray-900">Judith Black</div>
              <svg viewBox="0 0 2 2" width={3} height={3} aria-hidden="true" className="fill-gray-900">
                <circle cx={1} cy={1} r={1} />
              </svg>
              <div className="text-gray-600">CEO of Workcation</div>
            </div> */}
          </figcaption>
        </figure>
      </div>
    </section>
  );
};

export default Mensaje;
